var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-full w-full flex items-center"},[_c('status-button',{attrs:{"status":_vm.$t(("goods-offer-status." + (_vm.params.status))),"color":_vm.color,"disabled":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }